import * as React from 'react';
import Checkbox from '../../components/Checkbox';

// default to just passing the English label through
var passthrough = function passthrough(s) {
  return s;
};

export var Toggle = function Toggle(_ref) {
  var _ref$t = _ref.t,
      t = _ref$t === void 0 ? passthrough : _ref$t;
  return /*#__PURE__*/React.createElement(Checkbox, {
    toggle: true,
    defaultChecked: true,
    className: "button basic inverted compact left-label",
    style: {
      backgroundColor: 'transparent'
    },
    label: t('New Experience')
  });
};
export default Toggle;